import {
  GET_CONSIGNERS,
  CREATE_CONSIGNER,
  GET_CONSIGNER_DETAILS,
  EDIT_BASIC_DETAILS,
  EDIT_VPA_DETAILS,
  CREATE_VPA_DETAILS,
  EDIT_PAYMENT,
  EDIT_BUSINESS,
  SAVE_ADDRESS,
  CREATE_ADDRESS,
  SAVE_GST,
  CREATE_GST,
  DELETE_POC,
  DELETE_ADDRESS,
  DELETE_GST,
  UPLOAD_DOCUMENT,
  RESET_FILE_UPLOAD,
  RESET_VIEW_URL,
  VIEW_FILE,
  UPLOAD_GST,
  VIEW_GST,
  GET_CONSIGNER_TYPE,
  GET_CASHBACK_TYPE,
  GET_CONSIGNER_STATUS,
  UPLOAD_CONSIGNER_FILE,
  EDIT_COMPLIANCES,
  VIEW_CONSIGNER_FILE,
  GET_VPA_DETAILS,
  GET_SEARCH_RESULTS,
  RESET_EDITED_STATUS,
  RESET_FILE_URL,
  EDIT_NOTIFICATION,
  CLEAR_FLAGS,
  GET_CONSIGNER_BILLING_DETAILS,
  UPDATE_BILLING_ACCOUNT,
  VIEW_PRE_SIGNED_URL,
  UPLOAD_PRE_SIGNED_URL,
  UPDATE_PAN_GST,
  GET_CONSIGNER_WALLLET_BALANCE,
  GET_CONSIGNERS_TRANCATION_LIST,
  GET_CONSIGNERS_TRANCATION_LIST_NEW,
  ADD_NEW_TRANSACTION,
  GET_WALLET_BALANCE,
  RESET_WALLET_TRANSACTION,
  GET_PAYMENT_SELECTION_TYPES,
  GET_BUSINESS_DETAILS,
} from './actions';
import { REQUEST, SUCCESS, FAILURE } from '../../../utils/actionGenerator';
import { initial } from 'lodash';

const defaultState = {
  consigners: [],
  cBasicDetails: {},
  cVpaDetails: {},
  cAddressDetails: {},
  cGstDetails: {},
  consignerCreated: false,
  addressEdited: false,
  addressCreated: false,
  paymentEdited: false,
  businessEdited: false,
  gstEdited: false,
  basicDetailsEdited: false,
  vpaDetailsEdited: false,
  gstCreated: false,
  addressDeleted: false,
  gstDeleted: false,
  uploaded: false,
  gstUploaded: false,
  fileName: '',
  fileUrl: '',
  viewUrl: '',
  consignerTypes: [],
  consignerStatuses: [],
  viewGstUrl: '',
  panUploaded: false,
  biltyUploaded: false,
  compliancesEdited: false,
  fileViewUrl: '',
  searchResults: [],
  billingDetails: [],
  billingAccountUpdated: false,
  panGstUpdated: false,
  gstUploadCode: '',
  panUploadCode: '',
  preSignedMediaUrl: '',
  // walletBalance:'',
  consignerTransactions: [],
  transList: [],
  cashbackTypes: [],
  addNewTransactionDone: '',
  mainWalletBalance: '',
  consignersCount: 0,
  searchResultsCount: 0,
  consignerPaymentModes: [],
  businessDetails: {},
  businessDetailsEdited: false,
  isFetching: true,
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case GET_CONSIGNERS[REQUEST]:
      return { ...state };
    case GET_CONSIGNERS[SUCCESS]:
      return {
        ...state,
        consigners: state.consigners.concat(action.response.consigners),
        consignersCount: (action.response.count && action.response.count) || null,
      };
    case GET_CONSIGNER_DETAILS[REQUEST]:
      return { ...state, cBasicDetails: {}, isFetching: true, cAddressDetails: {}, cGstDetails: {} };
    case GET_CONSIGNER_DETAILS[SUCCESS]:
      const { response } = action;
      return {
        ...state,
        basicDetailsEdited: false,
        cBasicDetails: response[0].data.data,
        cAddressDetails: response[1].data.data,
        cGstDetails: {},
        isFetching: false,
      };
    case GET_CONSIGNER_DETAILS[FAILURE]:
      return {
        ...state,
        basicDetailsEdited: false,
        cBasicDetails: {},
        cAddressDetails: {},
        cGstDetails: {},
        isFetching: false,
        // cBasicDetails: {
        //   name: 'Punjab Goodmovers Pvt. Ltd. ',
        //   phone: '9999689500',
        //   type: 'TRANSPORTER',
        //   status: 'VERIFIED',
        //   billingName: 'Punjab Goodmovers Pvt. Ltd. ',
        //   pan: 'AAFCP0264K',
        //   sampleBiltyURL: 'WhatsApp Image 2020-05-22 at 11.00.05 PM.jpeg',
        //   paymentCycle: 7.0,
        //   pocName: 'Jitender',
        //   pocNumber: '9310007731',
        //   salesManager: 'qweqwq',
        //   advancePaymentCycle: 172800,
        //   kycStatus: 'VERIFIED',
        //   insuranceAmount: 499.0,
        //   paymentRestrictionStatus: {
        //     status: 'Active',
        //     reason: null,
        //     extension: null,
        //     extensionProvision: null,
        //     extensionProvisionDailog: null,
        //   },
        //   gstType: '10.0% FCM',
        // },
        // cAddressDetails: [
        //   {
        //     id: 2010736,
        //     coords: [13.0826802, 80.2707184],
        //     address: 'Chennai',
        //     city: 'Chennai District',
        //     state: 'Tamil Nadu',
        //     pincode: '600003',
        //     consignerCode: 'WE12001201',
        //     pocList: [],
        //   },
        //   {
        //     id: 2010697,
        //     coords: [30.4765796, 76.5905317],
        //     address: 'Rajpura',
        //     city: 'Patiala',
        //     state: 'Punjab',
        //     pincode: '140401',
        //     consignerCode: 'WE12001201',
        //     pocList: [],
        //   },
        //   {
        //     id: 2010698,
        //     coords: [28.3515381, 76.9427774],
        //     address: 'Manesar',
        //     city: 'Gurugram',
        //     state: 'Haryana',
        //     pincode: '122051',
        //     consignerCode: 'WE12001201',
        //     pocList: [],
        //   },
        //   {
        //     id: 2009599,
        //     coords: [28.68627380000001, 77.2217831],
        //     address: 'Delhi',
        //     city: 'Central Delhi',
        //     state: 'Delhi',
        //     pincode: '110054',
        //     consignerCode: 'WE12001201',
        //     pocList: [],
        //   },
        //   {
        //     id: 2009600,
        //     coords: [22.572646, 88.36389500000001],
        //     address: 'Kolkata',
        //     city: 'Kolkata',
        //     state: 'West Bengal',
        //     pincode: '700012',
        //     consignerCode: 'WE12001201',
        //     pocList: [],
        //   },
        // ],
        // cGstDetails: { data: [] },
      };
    case CREATE_CONSIGNER[REQUEST]:
      return { ...state, consignerCreated: false };
    case RESET_FILE_UPLOAD:
      return { ...state, gstUploaded: false };
    case RESET_FILE_URL:
      return { ...state, fileViewUrl: '' };
    case RESET_EDITED_STATUS:
      return {
        ...state,
        compliancesEdited: false,
        basicDetailsEdited: false,
        vpaDetailsEdited: false,
      };
    case RESET_VIEW_URL:
      return { ...state, viewGstUrl: '' };
    case CREATE_CONSIGNER[SUCCESS]:
      return { ...state, consignerCreated: true };
    case SAVE_ADDRESS[REQUEST]:
      return { ...state, addressEdited: false };
    case SAVE_ADDRESS[SUCCESS]:
      return { ...state, addressEdited: true };

    // new cashback transaction added

    case ADD_NEW_TRANSACTION[REQUEST]:
      return { ...state, addNewTransactionDone: '' };
    case ADD_NEW_TRANSACTION[SUCCESS]:
      return { ...state, addNewTransactionDone: true };
    case ADD_NEW_TRANSACTION[FAILURE]:
      return { ...state, addNewTransactionDone: false };

    case EDIT_PAYMENT[REQUEST]:
      return { ...state, paymentEdited: false };
    case EDIT_PAYMENT[SUCCESS]:
      return { ...state, paymentEdited: true };
    case EDIT_PAYMENT[FAILURE]:
      return { ...state, paymentEdited: false };

    case EDIT_BUSINESS[REQUEST]:
      return { ...state, businessEdited: false };
    case EDIT_BUSINESS[SUCCESS]:
      return { ...state, businessEdited: true };
    case EDIT_BUSINESS[FAILURE]:
      return { ...state, businessEdited: false };

    case EDIT_NOTIFICATION[REQUEST]:
      return { ...state, notificationEdited: false };
    case EDIT_NOTIFICATION[SUCCESS]:
      return { ...state, notificationEdited: true };
    case EDIT_NOTIFICATION[FAILURE]:
      return { ...state, notificationEdited: false, errorMessage: action.response.message };
    case CLEAR_FLAGS:
      return {
        ...state,
        notificationEdited: false,
        errorMessage: '',
      };
    case GET_VPA_DETAILS[REQUEST]:
      return { ...state, cVpaDetails: {} };
    case GET_VPA_DETAILS[SUCCESS]:
      return { ...state, cVpaDetails: action.response };
    case GET_SEARCH_RESULTS[REQUEST]:
      return { ...state };
    case GET_SEARCH_RESULTS[SUCCESS]:
      return {
        ...state,
        // searchResults: state.searchResults.concat(action.response.consigners),

        searchResults: action.response.consigners,
        searchResultsCount: action.response.count,
      };
    case CREATE_ADDRESS[REQUEST]:
      return { ...state, addressCreated: false };
    case CREATE_ADDRESS[SUCCESS]:
      return { ...state, addressCreated: true };

    case UPLOAD_CONSIGNER_FILE[REQUEST]:
      return { ...state, panUploaded: false, biltyUploaded: false };
    case UPLOAD_CONSIGNER_FILE[SUCCESS]:
      if (action.params.docType === 'BILTY') {
        return { ...state, panUploaded: false, biltyUploaded: true };
      } else if (action.params.docType === 'PAN') {
        return { ...state, panUploaded: true, biltyUploaded: false };
      } else {
        return { ...state };
      }
    case SAVE_GST[REQUEST]:
      return { ...state, gstEdited: false };
    case SAVE_GST[SUCCESS]:
      return { ...state, gstEdited: true };
    case EDIT_BASIC_DETAILS[REQUEST]:
      return { ...state, basicDetailsEdited: false };
    case EDIT_BASIC_DETAILS[SUCCESS]:
      return { ...state, basicDetailsEdited: true };
    case EDIT_VPA_DETAILS[REQUEST]:
      return { ...state, vpaDetailsEdited: false };
    case EDIT_VPA_DETAILS[SUCCESS]:
      return { ...state, vpaDetailsEdited: true };
    case VIEW_CONSIGNER_FILE[REQUEST]:
      return { ...state, fileViewUrl: '' };
    case VIEW_CONSIGNER_FILE[SUCCESS]:
      return { ...state, fileViewUrl: action.response };
    case CREATE_VPA_DETAILS[REQUEST]:
      return { ...state, vpaDetailsEdited: false };
    case CREATE_VPA_DETAILS[SUCCESS]:
      return { ...state, vpaDetailsEdited: true };
    case UPLOAD_GST[REQUEST]:
      return { ...state, gstUploaded: false, fileName: '' };
    case UPLOAD_GST[SUCCESS]:
      return { ...state, gstUploaded: action.response.ok, fileName: action.params.fileName };
    case VIEW_GST[REQUEST]:
      return { ...state, viewGstUrl: '' };
    case VIEW_GST[SUCCESS]:
      return { ...state, viewGstUrl: action.response.viewUrl };
    case CREATE_GST[REQUEST]:
      return { ...state, gstCreated: false };
    case CREATE_GST[SUCCESS]:
      return { ...state, gstCreated: true };
    case DELETE_POC[REQUEST]:
      return { ...state };
    case DELETE_POC[SUCCESS]:
      return { ...state, deleted: true };
    case UPLOAD_DOCUMENT[REQUEST]:
      return { ...state, uploaded: false };
    case UPLOAD_DOCUMENT[SUCCESS]:
      return { ...state, uploaded: true, fileUrl: action.response };
    case VIEW_FILE[REQUEST]:
      return { ...state, viewUrl: '' };
    case VIEW_FILE[SUCCESS]:
      return { ...state, viewUrl: action.response };
    case GET_CONSIGNER_TYPE[REQUEST]:
      return { ...state, consignerTypes: [] };
    case GET_CONSIGNER_TYPE[SUCCESS]:
      return { ...state, consignerTypes: action.response };
    // consignerTypes: {
    //   consignerTypes: ['SME', 'TRANSPORTER', 'BROKER', 'ENTERPRISE', 'SME_HP', 'SME_RFTL'],
    //   consignerGstTypes: {
    //     FCM_5: '5% FCM',
    //     FCM_INDIVIDUAL: '10% FCM',
    //     FCM_12: '15% FCM',
    //   },
    // },
    case GET_CASHBACK_TYPE[REQUEST]:
      return { ...state, cashbackTypes: [] };
    case GET_CASHBACK_TYPE[SUCCESS]:
      return { ...state, cashbackTypes: action.response.data.types };

    case GET_CONSIGNER_STATUS[REQUEST]:
      return { ...state, consignerStatuses: [] };
    case GET_CONSIGNER_STATUS[SUCCESS]:
      return { ...state, consignerStatuses: action.response };
    case EDIT_COMPLIANCES[REQUEST]:
      return { ...state, compliancesEdited: false };
    case EDIT_COMPLIANCES[SUCCESS]:
      return { ...state, compliancesEdited: true };
    case DELETE_ADDRESS[REQUEST]:
      return { ...state, addressDeleted: false };
    case DELETE_ADDRESS[SUCCESS]:
      return { ...state, addressDeleted: true };
    case DELETE_GST[REQUEST]:
      return { ...state, gstDeleted: false };
    case DELETE_GST[SUCCESS]:
      return { ...state, gstDeleted: true };
    case GET_CONSIGNER_BILLING_DETAILS[SUCCESS]:
      return {
        ...state,
        billingDetails: action.response,
      };
    case UPDATE_BILLING_ACCOUNT[REQUEST]:
      return { ...state, billingAccountUpdated: false };
    case UPDATE_BILLING_ACCOUNT[SUCCESS]:
      return { ...state, billingAccountUpdated: true };
    case UPDATE_PAN_GST[REQUEST]:
      return { ...state, panGstUpdated: false };
    case UPDATE_PAN_GST[SUCCESS]:
      return { ...state, panGstUpdated: true };
    case VIEW_PRE_SIGNED_URL[REQUEST]:
      return { ...state, preSignedMediaUrl: '' };
    case VIEW_PRE_SIGNED_URL[SUCCESS]:
      const viewPreSigned_mediaUrl = action?.response?.data?.frontImgUrl ?? '';
      return { ...state, preSignedMediaUrl: viewPreSigned_mediaUrl };
    case UPLOAD_PRE_SIGNED_URL[REQUEST]:
      const request_documentType = action?.payload?.documentType ?? '';
      if (request_documentType === 'GST') {
        return { ...state, gstUploadCode: '' };
      } else if (request_documentType === 'PAN_CARD') {
        return { ...state, panUploadCode: '' };
      } else {
        return { ...state };
      }
    case UPLOAD_PRE_SIGNED_URL[SUCCESS]:
      const success_documentType = action?.response?.chainedRequestData?.documentType ?? '';
      const frontImgResourceKey = action?.response?.response?.data?.docCode ?? '';
      //       const frontImgResourceKey = action?.response?.response?.data?.frontImgResourceKey ?? '';
      // const docCode = frontImgResourceKey.substring(
      //   frontImgResourceKey.indexOf('_') + 1,
      //   frontImgResourceKey.lastIndexOf('.'),
      // );
      if (success_documentType === 'GST') {
        return { ...state, gstUploadCode: frontImgResourceKey };
      } else if (success_documentType === 'PAN_CARD') {
        return { ...state, panUploadCode: frontImgResourceKey };
      } else {
        return { ...state };
      }

    case GET_CONSIGNERS_TRANCATION_LIST[REQUEST]:
      return { ...state };
    case GET_CONSIGNERS_TRANCATION_LIST[SUCCESS]:
      return {
        ...state,
        consignerTransactions: action.response.data.transactions,
      };
    case GET_CONSIGNERS_TRANCATION_LIST[FAILURE]:
      return {
        ...state,
        consignerTransactions: [
          {
            type: 'cashback',
            desc: 'Payment ID 123123131231231',
            time: 16223344879,
            amountInPaisa: -746347,
          },
        ],
      };
    case GET_CONSIGNERS_TRANCATION_LIST_NEW[REQUEST]:
      return { ...state };
    case GET_CONSIGNERS_TRANCATION_LIST_NEW[SUCCESS]:
      return {
        ...state,
        transList:
          action.response.data.transactions.length === 0
            ? action.response.data.transactions
            : state.transList.concat(action.response.data.transactions),
        consignerTransactions: action.response.data.totalElements,
      };
    case GET_CONSIGNERS_TRANCATION_LIST_NEW[FAILURE]:
      return {
        ...state,
        transList: [],
      };
    case RESET_WALLET_TRANSACTION:
      return {
        ...state,
        transList: [],
      };
    case GET_WALLET_BALANCE[REQUEST]:
      return { ...state };
    case GET_WALLET_BALANCE[SUCCESS]:
      return {
        ...state,
        mainWalletBalance: action.response.data.balanceInPaisa,
      };
    case GET_WALLET_BALANCE[FAILURE]:
      return {
        ...state,
        mainWalletBalance: 0,
      };
    case GET_PAYMENT_SELECTION_TYPES[REQUEST]:
      return { ...state };
    case GET_PAYMENT_SELECTION_TYPES[SUCCESS]:
      return {
        ...state,
        consignerPaymentModes: action.response,
        paymentEdited: false,
      };
    case GET_PAYMENT_SELECTION_TYPES[FAILURE]:
      return {
        ...state,
        consignerPaymentModes: [],
        paymentEdited: false,
      };
    case GET_BUSINESS_DETAILS[REQUEST]:
      return { ...state };
    case GET_BUSINESS_DETAILS[SUCCESS]:
      return {
        ...state,
        businessDetails: action.response,
        businessDetailsEdited: false,
        businessEdited: false,
      };
    case GET_BUSINESS_DETAILS[FAILURE]:
      return {
        ...state,
        businessDetails: {},
        businessDetailsEdited: false,
        businessEdited: false,
      };

    default:
      return state;
  }
}
// indentCount: (action.response.count && action.response.count) || null,

// 0: {type: "Trip Payment", desc: "Demand ID: 2079516", time: 1654608525, amountInPaisa: 2400,…}

export const getConsigners = (state) => state.consigner.consigners;
export const consignersCount = (state) => state.consigner.consignersCount;

export const getActiveBasicDetails = (state) => state.consigner.cBasicDetails;
export const getConsignerDetailsFetching = (state) => state.consigner.isFetching;
export const getActiveVpa = (state) => state.consigner.cVpaDetails;
export const getActiveAddress = (state) => state.consigner.cAddressDetails;
export const getActiveGst = (state) => state.consigner.cGstDetails;
// export const getConsignerWalletBalance = (state) => state.consigner.walletBalance;

export const getConsignerReducer = (state) => state.consigner;
export const getFileUrl = (state) => state.consigner.fileUrl;
export const getViewUrl = (state) => state.consigner.viewUrl;
export const getUploadedStatus = (state) => state.consigner.gstUploaded;
export const getFileName = (state) => state.consigner.fileName;

export const getConsignerTypes = (state) => state.consigner.consignerTypes;

export const getConsignerStatuses = (state) => state.consigner.consignerStatuses;
export const getPanUploaded = (state) => state.consigner.panUploaded;
export const getBiltyUploaded = (state) => state.consigner.biltyUploaded;
export const getVpaDetails = (state) => state.consigner.cVpaDetails;
export const getSearchResults = (state) => state.consigner.searchResults;

export const searchResultsCount = (state) => state.consigner.searchResultsCount;

export const getBillingDetails = (state) => state.consigner.billingDetails;
export const viewPreSignedUrl = (state) => state.consigner.viewPreSignedUrl;
export const uploadPreSignedUrl = (state) => state.consigner.uploadPreSignedUrl;
export const getBillingAccountUpdated = (state) => state.consigner.billingAccountUpdated;
export const getPanGstUpdated = (state) => state.consigner.panGstUpdated;
export const getGstUploadCode = (state) => state.consigner.gstUploadCode;
export const getPanUploadCode = (state) => state.consigner.panUploadCode;
export const getPreSignedMediaUrl = (state) => state.consigner.preSignedMediaUrl;
export const consignerTransactionsList = (state) => state.consigner.consignerTransactions;
export const getConsignerPaymentModesState = (state) => state.consigner.consignerPaymentModes;
export const getConsignerBusinessDetailsState = (state) => state.consigner.businessDetails;
